import CardSection from 'components/common/CardSection';
import React from 'react';
import { useAppSelector } from 'redux/hooks';
import { Space } from 'antd';
import { isEmpty } from 'lodash-es';
import EmptyData from 'containers/Advertisement/components/AdvertisementDetail/EmptyData';
import ChildCard from './ChildCard';

const ChildrenInfo = () => {
  const data = useAppSelector((state) => state.contacts.currentData?.children);

  return (
    <div className="mt-24">
      <CardSection title="children.childrenInformation">
        <div className="px-24 py-20">
          {isEmpty(data) ? (
            <div className="text-gray-500">
              <EmptyData description="contacts.emptyChildrenDesc" />
            </div>
          ) : (
            <Space className="flex" direction="vertical" size={20}>
              {data?.map((item) => (
                <ChildCard childItem={item} />
              ))}
            </Space>
          )}
        </div>
      </CardSection>
    </div>
  );
};

export default ChildrenInfo;
